import { useAppSelector } from '../hooks/redux';

export function can(permission: string, permissions: string[] = []): boolean {
  return permissions.includes(permission);
}

export function usePermission(permission: string): boolean {
  const permissions = useAppSelector((state) => state.auth.user?.permissions ?? []);
  return can(permission, permissions);
}
